import LoadingMixin from "../mixins/loading-mixin";
import ErrorsMixin from "../mixins/errors-mixin";
import TimerMixin from "../mixins/timer-mixin";

export default {
    mixins: [LoadingMixin, ErrorsMixin, TimerMixin],
    data() {
        return {
            code: ''
        }
    },
    computed: {
        phone() {
            return this.$store.getters.getPhone
        }
    },
    methods: {
        backToPhone() {
            this.$store.commit('setStep', 'enterPhone')
        },
        resendConfirmCode() {
            console.log('mixin resendConfirmCode')
        },
        confirmCode() {
            console.log('mixin confirmCode')
        }
    },
    // language=Vue
    template: `
      <div class="upblock__step">
      <div class="upblock__title">
        <button class="btn-turn" @click="backToPhone">&#8592;</button>
        <span>{{$Bitrix.Loc.getMessage('JS_MS_AF_CONFIRMATION')}}</span>
      </div>
      <p>
        {{$Bitrix.Loc.getMessage('JS_MS_AF_CONFIRM_TEXT')}}
        <nobr>{{phone}}:</nobr>
      </p>
      <div class="upblock__body js-val-container">
        <div class="upblock__body-wrapper">
          <div class="b-form-field-errors"
               v-if="commonErrors.length > 0"
          >
            <div class="b-form-field-error"
                 v-for="(errorText, i) in commonErrors"
                 :key="i"
            >
              {{errorText}}
            </div>
          </div>
          <div class="b-form-field">
            <div class="b-form-field__wrapper">
              <input class="b-form-field__input" 
                     type="number" 
                     :placeholder="$Bitrix.Loc.getMessage('JS_MS_AF_CODE_PLACEHOLDER')"
                     v-model="code"
              >
            </div>
            <div class="b-form-field-error"
                 v-if="error.length > 0">
              {{error}}
            </div>
          </div>
        </div>
        <div class="upblock__body-button js-btn-submit"
             v-if="!localLoading"
             @click="confirmCode"
        >
          {{$Bitrix.Loc.getMessage('JS_MS_AF_CONFIRM')}}
        </div>
        <div class="upblock__body-button js-btn-submit on-load"
             v-else
        >
          {{$Bitrix.Loc.getMessage('JS_MS_AF_CONFIRMATION')}}
        </div>
        <p class="sub-t">
          <small v-if="currentTime > 0">{{$Bitrix.Loc.getMessage('JS_MS_AF_COUNTER_TEXT', {'#CURRENT_TIME#': this.currentTime})}}</small>
          <a v-else
             class=""
             @click="resendConfirmCode"
          >
            <small>{{$Bitrix.Loc.getMessage('JS_MS_AF_RESEND_CODE')}}</small>
          </a>
        </p>
      </div>
      </div>
    `
}